import { useFormContext } from "react-hook-form";

export type HiddenInputProps = {
  source: string;
  value?: string | number;
};

export default function HiddenInput(props: HiddenInputProps) {
  const { value, source } = props;
  const { register } = useFormContext();

  return <input type="hidden" defaultValue={value} {...register(source)} />;
}
